<template>
  <div>
    <a id="open_encoding_modal" @click.prevent="showEncodingModal = true"
      class="u-visually-hidden">
      Open
    </a>
    <modal :show="showEncodingModal" @close="close">
      <div class="c-modal__body">
        <p>
          {{ gettext('Please do not use special characters such as &, < or >') }}
        </p>
      </div>
      <div class="c-modal__response u-mb-md u-text-right">
        <button @click="close" class="btn btn--ghost-primary">{{ gettext("Close") }}</button>
      </div>
    </modal>
  </div>
</template>

<script>
  export default {
    name: 'EncodingModal',

    props: {
    },

    data() {
      return {
        showEncodingModal: false,
      }
    },

    methods: {
      close() {
        this.showEncodingModal = false
      }
    }

  }
</script>


// WEBPACK FOOTER //
// js/EncodingModal.vue